import {
  BgContainer,
  CartSuccessPageContainer,
  CartSuccessPageFooter,
  Container,
  Divider,
  DownloadCartOrder,
  FooterBtn
} from './CartWizard.elements';
import Typography from 'components/Typography/Typography';
import styledTheme from 'common/theme';
import { DownloadIcon } from 'icons/indexed-icons/DownloadIcon';
import { Button } from 'components/Button';
import { saveAs } from 'file-saver';
import { OrderResponse } from 'types/parts';
import { CartPriceType } from './helper';
import CheckSuccess from 'icons/indexed-icons/CheckSuccess';
import { useTranslation } from 'react-i18next';
import { Loader } from 'components';

type Props = {
  orderDetails?: OrderResponse;
  orderUrl?: { pricedUrl?: string; nonePricedUrl?: string };
  url?: string;
  handleClose?: () => void;
  requestType?: CartPriceType;
  messageType?: 'Quote' | 'Order';
  erpOrderNumber?: { pricedNumber?: string; nonePricedNumber?: string };
  displayedOrderNumber?: string;
};
const CartSuccessPage = ({
  orderUrl,
  handleClose,
  requestType,
  erpOrderNumber
}: Props): JSX.Element => {
  const { t } = useTranslation('fpns');
  return (
    <Container>
      <CartSuccessPageContainer>
        {requestType === 'mix' && (
          <>
            {erpOrderNumber?.nonePricedNumber ? (
              <OrderSuccessScreen
                url={orderUrl?.nonePricedUrl}
                messageType={'Quote'}
                displayedOrderNumber={erpOrderNumber?.nonePricedNumber}
              />
            ) : (
              <Loader size={100} />
            )}
            <Divider />
            {erpOrderNumber?.pricedNumber ? (
              <OrderSuccessScreen
                url={orderUrl?.pricedUrl}
                messageType={'Order'}
                displayedOrderNumber={erpOrderNumber?.pricedNumber}
              />
            ) : (
              <Loader size={100} />
            )}
          </>
        )}
        {requestType === 'price' && (
          <>
            {erpOrderNumber?.pricedNumber ? (
              <OrderSuccessScreen
                url={orderUrl?.pricedUrl}
                messageType={'Order'}
                displayedOrderNumber={erpOrderNumber?.pricedNumber}
              />
            ) : (
              <Loader size={100} />
            )}
          </>
        )}
        {requestType === 'none-price' && (
          <>
            {erpOrderNumber?.nonePricedNumber ? (
              <OrderSuccessScreen
                url={orderUrl?.nonePricedUrl}
                messageType={'Quote'}
                displayedOrderNumber={erpOrderNumber?.nonePricedNumber}
              />
            ) : (
              <Loader size={100} />
            )}
          </>
        )}
      </CartSuccessPageContainer>
      <CartSuccessPageFooter>
        <BgContainer />
        <FooterBtn>
          <Button variant="filled-primary" onClick={handleClose}>
            {t('close')}
          </Button>
        </FooterBtn>
      </CartSuccessPageFooter>
    </Container>
  );
};

export default CartSuccessPage;

function OrderSuccessScreen({ url, messageType, displayedOrderNumber }: Props) {
  const downloadCartOrder = (url: string) => {
    const pathname = url?.split('?')[0];
    const pathnameParts = pathname?.split('/');
    const originalFilename = pathnameParts[pathnameParts?.length - 1];
    saveAs(url, originalFilename);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <CheckSuccess />
      <Typography weight="semi-bold" size={'1.25rem'} color={styledTheme.colors.green}>
        {messageType} Successfully placed!
      </Typography>
      <Typography weight="semi-bold" size={'1rem'} color={styledTheme.colors.gray800}>
        {messageType} Number: #{displayedOrderNumber || ''}
      </Typography>
      <Typography weight="semi-bold" size={'0.9rem'} color={styledTheme.colors.gray600}>
        An email confirmation will be sent to you
      </Typography>
      <DownloadCartOrder onClick={() => downloadCartOrder(url || '')} variant="text">
        <DownloadIcon />
        <Typography mb={0} color={styledTheme.JBTColors.mainColor}>
          Download {messageType} Summary
        </Typography>
      </DownloadCartOrder>
    </div>
  );
}
